module.exports = {
  TheNotYourCustomerSelect: 'Данная доверенная организация не является вашим клиентом, пожалуйста, выберите заново!',
  YourAuthorityIsInsufficient: 'У вас недостаточно прав.',
  SailingSchedule2: 'Расписание судов 2:',
  Voyage: 'Маршрут:',
  OverweightDescription: 'Объяснение перевеса:',
  LowestPrice: 'Минимальная цена',
  SailingSchedule: 'Расписание судов:',
  FullContainerFreightSharingDetails: 'Подробности тарифа FCL',
  FullContainerFCLFreight: 'Тариф FCL (полный контейнер)',
  LessContainerLoadLCLFreight: 'Тариф LCL (сборный груз)',
  AirCargoAIRFreight: 'Авиатариф (AIR)',
  All: 'Все',
  Code: 'Код',
  ChineseName: 'Название на китайском',
  EnglishName: 'Название на английском',
  Country: 'Страна',
  Region: 'Регион',
  AirFreightSurchargeDetails: 'Подробности авианакладных расходов',
  Empty: 'Пусто',
  LCLDestinationPortChargesDetails: 'Подробности портовых сборов LCL',
  AirCargoRateDetails: 'Подробности авиатарифа',
  SecondTransit: 'Транзит 2',
  SecondLegAircraftType: 'Тип самолета второго рейса',
  SecondLegFlightSchedule: 'Время второго рейса',
  SecondScheduleCannotBeEmpty: 'Время второго рейса не может быть пустым.',
  ProgramSettings: 'Настройки схемы',
  FullContainerFreightDetails: 'Подробности тарифа FCL',
  EuropeAndAmericaLinesDedicated: 'Для линий Европа-Америка',
  EmailCannotBeEmpty: 'Почта не может быть пустой',
  EmailFormatError: 'Неверный формат почты',
  DestinationAreaError: 'Ошибка в целевом регионе!',
  ContinueImporting: ', продолжить импорт?',
  FullContainerAddonFreightDetails: 'Подробности Addon тарифа FCL',
  FullContainerAdditionalInformationDetails: 'Подробности дополнительной информации FCL',
  LCLFreightDetails: 'Подробности тарифа LCL',
  CostPrice: 'Себестоимость',
  PeerPrice: 'Цена для партнеров',
  DirectCustomerPrice: 'Цена для клиентов',
  MarketPrice: 'Рыночная цена',
  LCLAddonFreightDetails: 'Подробности Addon тарифа LCL',
  YourPermissionIsNotEnough: 'У вас недостаточно прав.',
  SailingTime: 'Маршрут:',
  FCL: 'FCL (полный контейнер)',
  LCL: 'LCL (сборный груз)',
  FreightNumber: 'Номер тарифа:',
  CabinStatus: 'Статус места:',
  OurDumpingOfContainersOK: 'Мы не гарантируем отсутствие сброса контейнеров даже при подтверждении бронирования.',
  NoteAdditionalChargesWithBackground: 'Примечание: цена ALL IN включает пункты с серым фоном в дополнительных расходах.',
  Booking: 'Бронирование',
  ThisFareHasExpired: 'Этот тариф устарел!',
  NoFreightThatMeetsParty: 'В течение срока действия тарифа не удалось найти дату отправления, соответствующую требованиям к расписанию судов. Пожалуйста, свяжитесь с бронирующей стороной для подтверждения!',
  Subscribe: 'Подписка',
  SetEmailToReceiveInformation: 'Укажите email для получения информации по подписке',
  TheEmailCannotBeEmpty: 'Email не может быть пустым',
  SetCompanyToReceiveInformation: 'Выберите (дочернюю) компанию для получения подписки',
  SetYouWantToTo: 'Выберите партнеров для подписки',
  AdvancedSettings: 'Расширенные настройки',
  SubscriptionType: 'Тип подписки',
  PlaceOfDeparture: 'Место отправления',
  DischargePort: 'Место выгрузки',
  Airline: 'Авиакомпания',
  ShippingCompany: 'Судоходная компания',
  Confirm: 'Подтвердить',
  Reset: 'Сбросить',
  Refresh: 'Обновить',
  Cancel: 'Отмена',
  PleaseYouWillReceiveUpdated: 'Подпишитесь на интересующую вас информацию. При обновлении тарифов вы получите уведомление по email.',
  Add: 'Добавить',
  Edit: 'Редактировать',
  Delete: 'Удалить',
  GoBack: 'Назад',
  Save: 'Сохранить',
  SubCompany: 'Филиал',
  DeparturePort: 'Порт отправления',
  DepartureCountry: 'Страна отправления',
  DepartureArea: 'Регион отправления',
  DestinationPort: 'Порт назначения',
  DestinationCountryRegion: 'Страна (регион) назначения',
  DestinationArea: 'Регион назначения',
  FCLWeightLimitInformationDetails: 'Подробности о весовых ограничениях FCL',
  PleaseTheEntrustedContainerVolume: 'Пожалуйста, укажите количество заказанных контейнеров!',
  TheBelongToYourSelect: 'Этот заказчик не является вашим клиентом. Пожалуйста, выберите заново!',
  ExternalUser: 'Внешний пользователь',
  FCLSailingScheduleManagement: 'Управление расписанием FCL',
  ConfigSurchargeFcl: 'Настройка дополнительных сборов',
  FCLAdditionalFeeMaintenance: 'Обслуживание дополнительных сборов FCL',
  HsCode: 'Код HS',
  UnNo: 'Номер UN'
}
